import { render, staticRenderFns } from "./AppButtonExportAddTreament.vue?vue&type=template&id=8be892e4&scoped=true&"
import script from "./AppButtonExportAddTreament.vue?vue&type=script&lang=ts&"
export * from "./AppButtonExportAddTreament.vue?vue&type=script&lang=ts&"
import style0 from "./AppButtonExportAddTreament.vue?vue&type=style&index=0&id=8be892e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be892e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
